/** Shared shape for secrets returned by GET /organizations/:orgId/secrets */

export type SecretRow = {
  id: string;
  record_id?: string;
  vault_id: string;
  name: string;
  ciphertext: string;
  /** Decrypted value when the API could unlock the row (server-side AES-GCM). */
  value?: string | null;
  decrypt_error?: boolean;
  version: number;
  updated_at: string;
  tags?: string[];
};

export function displaySecret(row: SecretRow): string {
  if (row.decrypt_error) {
    return "(cannot decrypt — check SECRETS_MASTER_KEY on API server)";
  }
  if (row.value != null) return row.value;
  try {
    return decodeURIComponent(escape(atob(row.ciphertext)));
  } catch {
    return row.ciphertext;
  }
}

/** Normalize user tag input to API-safe lowercase tokens (matches server hint). */
export function parseTagInput(raw: string): string[] | null {
  const parts = raw
    .split(/[,\s]+/)
    .map((s) => s.trim().toLowerCase())
    .filter(Boolean);
  const out: string[] = [];
  for (const s of parts) {
    if (s.length > 64) return null;
    if (!/^[a-z0-9][a-z0-9._-]*$/.test(s)) return null;
    out.push(s);
  }
  return [...new Set(out)];
}
